<template>
  <div
    id="contactBtnContainer"
    class="contact-btn-container"
  >
    <div class="contact-btn-left">
      <transition name="fade">
        <div class="contact-card-container" v-show="contactCardShow">
          <div class="phone-container">
            <div class="title">
              <img src="@/assets/images/icon-phone.png" alt="" />
              <span>联系电话</span>
            </div>
            <div class="value">
              <span>{{ companyData.phone }}</span>
            </div>
          </div>
          <div class="wx-container">
            <div class="title">
              <img src="@/assets/images/icon-wx.png" alt="" />
              <span>客服微信</span>
            </div>
            <div class="qr-cord-container">
              <!-- <img src="" alt=""> -->
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="contact-btn-right">
      <div class="hover-container wave" @click="openContactCard">
        <img src="@/assets/images/icon-chat.png" alt="" />
        <span>联系客服</span>
      </div>
      <div class="contact-btn wave" @click="backTop">
        <img src="@/assets/images/icon-contact.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contactCardShow: false,
    };
  },
  mounted() {
    // 点击区域外关闭弹窗
    document.addEventListener("click", (e) => {
      const contactBtnContainer = document.getElementById(
        "contactBtnContainer"
      );

      if (contactBtnContainer && !contactBtnContainer.contains(e.target)) {
        this.contactCardShow = false;
      }
    });
  },
  methods: {
    openContactCard() {
      this.contactCardShow = !this.contactCardShow;
    },
    backTop() {
      document.getElementById("app").scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-btn-container {
  position: fixed;
  right: 20px;
  bottom: 80px;
  z-index: 9;
  display: flex;
  align-items: flex-end;
  .contact-btn-left {
    margin-right: 20px;
    .contact-card-container {
      width: 200px;
      height: 270px;
      padding: 31px 16px;
      background: #ffffff;
      border: 1px solid #e9eef5;
      box-shadow: 0 2px 16px 0 rgba(71, 75, 82, 0.06);
      border-radius: 4px 4px 0 0;
      .phone-container,
      .wx-container {
        .title {
          display: flex;
          align-items: center;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #222222;
          img {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
        }
        .value {
          margin-top: 10px;
          padding-left: 28px;
          font-family: PingFangSC-Regular;
          font-size: 20px;
          color: #7b8799;
        }
        .qr-cord-container {
          margin-top: 10px;
          margin-left: 28px;
          width: 100px;
          height: 100px;
          background: #e9eef5;
        }
      }
      .wx-container {
        margin-top: 20px;
      }
    }
  }
  .contact-btn-right {
    .hover-container {
      margin-bottom: 14px;
      padding: 12px 14px 0;
      width: 44px;
      height: 142px;
      background: #0764fb;
      border-radius: 46px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
      user-select: none;
      img {
        width: 21px;
        height: 20px;
        margin-bottom: 5px;
      }
    }
    .contact-btn {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: #ffffff;
      border: 1px solid #93bcff;
      box-shadow: 0 2px 10px 0 rgba(150, 167, 194, 0.13);
      img {
        width: 16px;
      }
      @include btn;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/components/contactBtn.vue